
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';
// import * as micropython from './micropython';
// import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class SHTC3 extends BasePeripheral {
    constructor() {
        super();
        this.id = 'shtc3';
        this.name = 'SHTC3 Temperature and Humidity Sensor';
        this.requirements = ['zephyr'];

        const settings: Array<Setting> = [
            {
                id: 'I2C',
                name: 'I2C Peripheral',
                settingType: SettingType.OPTION,
                refId: 'i2c',
                required: true,
                default: '',
            },
            {
                id: 'TEMPERATURE',
                name: 'Temperature',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'TEMP',
            },
            {
                id: 'HUMIDITY',
                name: 'Humidity',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'HUM',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
